
import { op_Addition, utcNow } from "../fable_modules/fable-library-js.5.3.0/DateOffset.js";
import { class_type } from "../fable_modules/fable-library-js.5.3.0/Reflection.js";

export const Clock_system = {
    UtcNow() {
        return utcNow();
    },
};

/**
 * A clock that always returns the same instant.
 */
export function Clock_fixed$0027(instant) {
    return {
        UtcNow() {
            return instant;
        },
    };
}

/**
 * A clock that returns (inner.UtcNow + delta).
 */
export function Clock_offset(inner, delta) {
    return {
        UtcNow() {
            return op_Addition(inner.UtcNow(), delta);
        },
    };
}

/**
 * A manually-advancing clock for deterministic tests.
 */
export class Clock_Manual {
    constructor(initial) {
        this.current = initial;
    }
    UtcNow() {
        const _ = this;
        return _.current;
    }
}

export function Clock_Manual_$reflection() {
    return class_type("Shared.Clock.Manual", undefined, Clock_Manual);
}

export function Clock_Manual_$ctor_Z53C0511E(initial) {
    return new Clock_Manual(initial);
}

export function Clock_Manual__Advance_Z342822E9(_, delta) {
    _.current = op_Addition(_.current, delta);
}

export function Clock_Manual__Set_Z53C0511E(_, value) {
    _.current = value;
}

//# sourceMappingURL=Clock.js.map
